// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__sM_jD","insightsList":"newBusinessInsightsMenu_insightsList__2ATyz","active":"newBusinessInsightsMenu_active__2H3VC"};